/**
 * External dependencies
 */
import React from 'react';
import ReactDom from 'react-dom';
import page from 'page';

/**
 * Internal dependencies
 */
import { isUserLoggedIn } from 'state/current-user/selectors';


export function redirectLoggedOut(context, next) {
    const state = context.store.getState();
    const userLoggedOut = !isUserLoggedIn(state);

    if (userLoggedOut) {
        // force full page reload to avoid SSR hydration issues.
        window.location = '/login';
        return;
    }

    next();
}

export function hydrate(context) {
    ReactDom.hydrate(context.layout, document.getElementById('root'));
}

export function render(context) {
    ReactDom.render(context.layout, document.getElementById('root'));
}

export function redirectLoggedIn(context, next) {
    const userLoggedIn = isUserLoggedIn(context.store.getState());

    if (userLoggedIn) {
        page.redirect('/');
        return;
    }

    next();
}